import DoublePanel from './DoublePanel';

export default DoublePanel;